import React from "react";
import CrossIcon from "../../../icons/cross.icon";
import PlusIcon from "../../../icons/plus.icon";
import DropdownSelector from "../../../Common/dropdown-selector";
import cn from "../../../../Utils/class-names.utils";
import styles from "./index.module.scss";

interface RoleItem {
  label: string;
  value: string;
}

interface RoleBadgesProps {
  roles: string[];
  availableRoles: RoleItem[];
  onAddRole: (role: string) => void;
  onRemoveRole: (role: string) => void;
  disabled?: boolean;
}

const RoleBadges = ({
  roles,
  availableRoles,
  onAddRole,
  onRemoveRole,
  disabled = false,
}: RoleBadgesProps) => {
  const availableRolesToAdd = availableRoles.filter(
    (role) => !roles.includes(role.value)
  );

  const handleAddRole = (item: { label: string; value: string }) => {
    onAddRole(item.value);
  };

  return (
    <div className={styles.rolesContainer}>
      {roles.map((role, index) => (
        <div 
          key={`${role}-${index}`} 
          className={cn(styles.roleBadge, { [styles.disabled]: disabled })}
        >
          <div className={styles.roleBadgeInner}>
            <div className={styles.roleText}>
              {role}
            </div>
          </div>

          {!disabled && (
            <button
              className={cn(styles.removeRoleButton, "my-button")}
              aria-label={`Remove ${role} role`}
              type="button"
              onClick={() => onRemoveRole(role)}
            >
              <CrossIcon width={10} height={10} />
            </button>
          )}
        </div>
      ))}

      {!disabled && availableRolesToAdd.length > 0 && (
        <DropdownSelector
          list={availableRolesToAdd}
          onItemSelected={handleAddRole}
          className={styles.addRoleDropdown}
          toggleClassName={styles.addRoleButtonToggle}
          menuClassName="f-14 line-height-22"
          popperConfig={{ strategy: "fixed" }}
          showSelectedIcon={false}
        >
          <div className={styles.addRoleButton}>
            <PlusIcon width={16} height={16} className={styles.addRoleIcon} />
          </div>
        </DropdownSelector>
      )}
    </div>
  );
};

export default RoleBadges;

